import { render } from "./ModalArchiveVersions.vue?vue&type=template&id=614dc873&scoped=true"
import script from "./ModalArchiveVersions.vue?vue&type=script&lang=js"
export * from "./ModalArchiveVersions.vue?vue&type=script&lang=js"

import "./ModalArchiveVersions.vue?vue&type=style&index=0&id=614dc873&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-614dc873"]])

export default __exports__